import React from "react";
import { PageBuilderPackageCardItemFragment } from "types/graphql-types";
import PageBuilderButtonCTA from "../PageBuilderButtonCTA";
import TextBox from "components/TextBox/TextBox";
import PackageCard from "components/Card/PackageCard/PackageCard";

type Props = PageBuilderPackageCardItemFragment;

const PageBuilderPackageCardItem: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  subtitle,
  content,
  footer,
  ctaButtons
}) => {
  const ctaButton = ctaButtons && ctaButtons.length > 0 && ctaButtons[0];

  return (
    <PackageCard
      title={title?.localized}
      subtitle={subtitle?.localized}
      footer={<TextBox fontSize="inherit" content={footer?.localized} />}
      ctaButton={
        ctaButton ? (
          <PageBuilderButtonCTA
            {...ctaButton}
            defaultButtonVariant="primary"
            full
          />
        ) : undefined
      }
    >
      <TextBox fontSize="inherit" content={content?.localized} />
    </PackageCard>
  );
};

export default PageBuilderPackageCardItem;
